export default [
   {
    header: 'Dashboards',
  },
  {
    title: 'Sales Dashboard',
    route: 'dashboard-sales',
    icon: 'TrendingUpIcon',
  },
  {
    title: 'Lager & Standorte',
    route: 'dashboard-storage',
    icon: 'PackageIcon',
  },
]
